'use es6';

export const COOKIES_WITHOUT_BANNER = 'COOKIES_WITHOUT_BANNER';
export const OPT_IN = 'OPT_IN';
export const NO_COOKIES = 'NO_COOKIES';
export const COOKIES_BY_CATEGORY = 'COOKIES_BY_CATEGORY';

// Equivalent to OPT_IN with hide decline
export const NOTIFY = 'NOTIFY';
export const SETTINGS_PRIVACY_POLICIES = {
  0: COOKIES_WITHOUT_BANNER,
  1: OPT_IN,
  2: NO_COOKIES,
  3: COOKIES_BY_CATEGORY
};
export const getBannerPolicyFromPrivacySetting = privacySetting => {
  if (privacySetting.mode === OPT_IN && privacySetting.hideDecline) {
    return NOTIFY;
  }
  return privacySetting.mode;
};
export const isOptIn = privacySetting => {
  if (!privacySetting) {
    return false;
  }
  return [OPT_IN, COOKIES_BY_CATEGORY].includes(getBannerPolicyFromPrivacySetting(privacySetting));
};